export const EXPENSE_STATUS_WAITING_REVIEW = "waiting_review";
export const EXPENSE_STATUS_APPROVED = "approved";
export const EXPENSE_STATUS_REJECTED = "rejected";

export const EXPENSE_STATUSES = {
    [EXPENSE_STATUS_WAITING_REVIEW]: "In attesa di revisione",
    [EXPENSE_STATUS_APPROVED]: "Approvata",
    [EXPENSE_STATUS_REJECTED]: "Rifiutata"
};

export const EXPENSE_TYPE_GENERIC = "generic";
export const EXPENSE_TYPE_FUEL = "fuel";
export const EXPENSE_TYPE_PARKING = "parking";
export const EXPENSE_TYPE_TOLL = "toll";
export const EXPENSE_TYPE_MEAL = "meal";
export const EXPENSE_TYPE_LODGING = "lodging";

export const EXPENSE_TYPES = {
    [EXPENSE_TYPE_GENERIC]: "Altro",
    [EXPENSE_TYPE_FUEL]: "Carburante",
    [EXPENSE_TYPE_PARKING]: "Parcheggio",
    [EXPENSE_TYPE_TOLL]: "Pedaggio",
    [EXPENSE_TYPE_MEAL]: "Pasto",
    [EXPENSE_TYPE_LODGING]: "Alloggio"
};

export const EXPENSE_STATUS_BADGE_CLASSES = {
    [EXPENSE_STATUS_WAITING_REVIEW]: "badge badge-warning",
    [EXPENSE_STATUS_APPROVED]: "badge badge-success",
    [EXPENSE_STATUS_REJECTED]: "badge badge-danger"
};
